import { useMemo } from "react";
import type { RosterData } from "../lib/rosterData";
import { watchByClient, type WatchItem } from "../lib/reviewQueue";
import { useRosterData } from "./useRosterData";
import { useReviewQueue } from "./useReviewQueue";

/* W126 — ONE CLIENT'S TWO-WEEK WATCH, for the client page's `Watch` block (his word, 2026-10-01: the row's sentence left
 * the Clients row, and its words live here).
 *
 * ⚠️ THE SAME FACTS AS THE ROW'S `Watch N`, BY THE SAME HOOKS — never a second rule: the roster's reads (`useRosterData`)
 * and the review queue's (`useReviewQueue`, the badge's and the Dashboard's), then `watchByClient`. The roster is NARROWED
 * to this one client before the queue reads, so the queue's reads are this client's alone (the watch of one client depends
 * on that client's days only — `watchItems` never compares across clients). Proposals are not read: the watch does not
 * use them.
 *
 * `null` while loading or on a failed read — the page draws NO block then, never a guessed one; `[]` = read, nobody
 * watched. */
const NO_PROPOSALS: Readonly<Record<string, number>> = {};

export function useClientWatch(clientId: string, today: Date): WatchItem[] | null {
  const state = useRosterData(0, today);
  const data = useMemo<RosterData | null>(() => {
    if (state.status !== "ready") return null;
    return { ...state.data, rows: state.data.rows.filter((r) => r.clientId === clientId) };
  }, [state, clientId]);
  const queue = useReviewQueue(data, NO_PROPOSALS, today);
  return useMemo(() => (queue.status === "ready" ? (watchByClient(queue.queue).get(clientId) ?? []) : null), [queue, clientId]);
}
